import { render, staticRenderFns } from "./AddEmailModal.vue?vue&type=template&id=4708e124&"
import script from "./AddEmailModal.vue?vue&type=script&lang=ts&"
export * from "./AddEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports